import MaterialFilter from './src'
MaterialFilter.install = (Vue) => {
    Vue.component(MaterialFilter.name, MaterialFilter)
}
export default MaterialFilter



// WEBPACK FOOTER //
// ./packages/material-filter/index.js